import { Controller } from 'react-hook-form';
import React, { useEffect } from 'react';
import { Checkbox } from 'src/components/ui/checkbox';

export const ToneOfVoiceEmojiField = ({
  field,
  data,
  control,
  readonly,
  setValue,
  watch,
  compact,
}) => {
  const fieldValue = watch('pf_tone_of_voice_emoji');

  useEffect(() => {
    if (readonly) {
      if (typeof data !== 'undefined') {
        setValue('pf_tone_of_voice_emoji', data);
      }
      return;
    }

    if (fieldValue) {
      setValue('pf_tone_of_voice_emoji', fieldValue);
      return;
    }

    if (typeof data !== 'undefined') {
      setValue('pf_tone_of_voice_emoji', data);
    }
  }, [readonly, data, field]);

  return Boolean(field) ? (
    <Controller
      control={control}
      name="pf_tone_of_voice_emoji"
      render={({ field: { onChange, value } }) => (
        <div className="flex items-center w-full">
          <label
            htmlFor={`sub-${field.key}`}
            className="pb-2.5 w-full text-xs flex items-center gap-2.5 text-ebony_opacity_30 cursor-pointer font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            <Checkbox
              disabled={readonly}
              id={`sub-${field.key}`}
              checked={value}
              onCheckedChange={onChange}
            />
            <p>Emoji usage</p>
          </label>
        </div>
      )}
    />
  ) : null;
};
